import { useEffect } from 'react';
import { useQuery } from 'react-query';
import { Outlet, useParams } from 'react-router-dom';
import { getSingleBlobAPI } from '@myme/api';
import { getSingleBlob } from '@myme/logic';
import { useUnmount } from 'src/hooks';
import { useBlobContext } from './context';
import { BlobEditorProvider } from './context/BlobContext';

interface Params {
  blobId?: string;
}

export const BlobContextWrapper = () => {
  return (
    <BlobEditorProvider>
      <BlobEditorDataWrapper />
    </BlobEditorProvider>
  );
};

const BlobEditorDataWrapper = () => {
  const {
    dispatchClearEditor,
    dispatchSetInitialBlobData,
    editor: { isCreator }
  } = useBlobContext();
  const { blobId }: Params = useParams();

  const shouldEnableGetBlobData = Boolean(!isCreator && !!blobId && blobId !== 'creating-blob');

  const singleBlobData = useQuery(
    [...getSingleBlobAPI.cacheKeys, blobId],
    async () => {
      if (blobId) {
        return getSingleBlob(blobId);
      }

      return null;
    },
    {
      enabled: shouldEnableGetBlobData,
      refetchOnWindowFocus: false
    }
  );

  useEffect(() => {
    if (singleBlobData.data) {
      dispatchSetInitialBlobData(singleBlobData.data.data);
    }
  }, [singleBlobData.data]);

  useUnmount(() => {
    dispatchClearEditor();
  });

  return <Outlet />;
};
